export default {
  PLACEHOLDER_SELECT_ADDRESS: 'Seleziona un indirizzo',
  INVOICES_MY_INVOICES: 'Le mie fatture',
  INVOICES_INVOICES_PURCHASE_HISTORY: 'Fatture / Storico ordini',
  INVOICES_NO_INVOICES_FOUND: 'Al momento non sono disponibili fatture.',
  INVOICES_ORDER_NUMBER: "N° d'ordine",
  INVOICES_INVOICE_DATE: 'Data della fattura',
  INVOICES_PAYMENT_METHOD: 'Metodo di pagamento',
  INVOICES_PRICES: 'Prezzo',
  INVOICES_DOWNLOAD: 'Download',
  INVOICES_PER_PAGE: '/ pagina',
  PAYMENT_METHOD_CREDIT_CARD: 'Carta di credito',
  PAYMENT_METHOD_ADVANCED_PAYMENT: 'Bonifico bancario',
  CHECKOUT_DELIVER_TO: 'Consegna a:',
  CHECKOUT_BILLING_TO: 'Intestatario fattura:',
  CHECKOUT_SAMPLE_COPIES_ADDRESS: 'Indirizzo di spedizione copie campione',
  CARD_ITEM_BUTTON_SAMPLE_COPIES: 'Copie campione',
  CUSTOMER_SERVICE_TITLE: 'Servizio clienti',
  CUSTOMER_SERVICE_CONTACT: 'Contatto',
  CUSTOMER_SERVICE_AVAILABLE_FROM: 'Disponibile dalle',
  CUSTOMER_SERVICE_AVAILABLE_UNTIL: 'Disponibile fino alle',
  CHANGE_PW_TITLE: 'La tua password deve essere modificata.',
  CHANGE_PW_CHANGE: 'Aggiorna le credenziali',
  CHANGE_PW_CURRENT_PW: 'Password corrente*',
  CHANGE_PW_NEW_PW: 'Nuova password*',
  CHANGE_PW_REPEAT_PW: 'Ripeti la nuova password*',
  CHANGE_PW_EMAIL_MISMATCH: "L'indirizzo email non corrisponde all'utente attualmente connesso.",

  ASSERT_FIELD_REQUIRED: 'Campo obbligatorio',
  ASSERT_MINIMUM_LENGTH: 'Numero minimo di caratteri:',
  ASSERT_MAXIMUM_LENGTH: 'Numero massimo di caratteri:',
  ASSERT_BOTH_FIELDS_MUST_BE_EQUAL: 'I due campi devono coincidere',
  ASSERT_INVALID_EMAIL: 'Inserisci un indirizzo email valido',
  ASSERT_INVALID_PASSWORD:
    'La password deve contenere almeno 8 caratteri, tra cui una lettera maiuscola, una minuscola, un numero e un carattere speciale',

  AWS_COGNITO_ERROR_ATTEMPT_LIMIT: 'Troppi tentativi. Riprova più tardi.',
  AWS_COGNITO_ERROR_USER_NOT_CONFIRMED:
    'Non hai ancora confermato il tuo account. Clicca sul link che ti abbiamo inviato via email.',
  AWS_COGNITO_ERROR_PASSWORD_RESET_REQUIRED: 'Per accedere, devi prima reimpostare la password.',
  AWS_COGNITO_ERROR_NETWORK: 'Si è verificato un problema di connessione. Riprova tra qualche istante.',
  AWS_COGNITO_ERROR_TOO_MANY_REQUESTS: 'Il servizio è temporaneamente occupato. Riprova tra qualche istante.',
  AWS_COGNITO_ERROR_LIMIT_EXCEEDED:
    'Hai effettuato troppe richieste per questo account. Attendi qualche minuto e riprova.',
  AWS_COGNITO_ERROR_SESSION_EXPIRED: 'La sessione è scaduta. Accedi di nuovo con la password temporanea.',

  LOGIN_EMAIL: 'Indirizzo email*',
  LOGIN_PASSWORD: 'Password*',
  LOGIN_LOGIN: 'Accedi',
  LOGIN_FORGOT_PASSWORD: 'Reimposta la password',

  FORGOT_PASSWORD_CODE_SENT:
    "Se l'indirizzo email è già associato a un account, riceverai a breve un codice di verifica via email.",
  FORGOT_PASSWORD_INVALID_CODE: 'Invalid verification code provided, please try again.',
  FORGOT_PASSWORD_SEND_CODE: 'Invia il codice di verifica',
  FORGOT_PASSWORD_EMAIL: 'Indirizzo email*',
  FORGOT_PASSWORD_RESET_CODE: 'Codice di verifica*',
  FORGOT_PASSWORD_NEW_PASSWORD: 'Nuova password*',
  FORGOT_PASSWORD_REPEAT_NEW_PASSWORD: 'Ripeti la nuova password*',
  FORGOT_PASSWORD_BACK_TO_LOGIN: 'Torna al login',
  FORGOT_PASSWORD_RESET_PASSWORD: 'Reimposta la password',
  FORGOT_PASSWORD_CODE_RESENT:
    "Se l'indirizzo email è già associato a un account, riceverai a breve un codice di verifica via email.",
  FORGOT_PASSWORD_HINTS_TITLE: "Non hai ricevuto l'email?",
  FORGOT_PASSWORD_HINT_SPAM: 'Controlla la cartella spam o posta indesiderata',
  FORGOT_PASSWORD_HINT_EMAIL: "Verifica di aver inserito l'indirizzo email corretto",
  FORGOT_PASSWORD_CHANGE_EMAIL: "Modifica l'indirizzo email",
  FORGOT_PASSWORD_HINT_RESEND: 'Invia di nuovo il codice',
  LOGIN_RESEND_CONFIRMATION: "Invia di nuovo l'email di conferma",
  LOGIN_RESEND_CONFIRMATION_SUCCESS: 'Ti abbiamo inviato una nuova email di conferma.',
  LOGIN_RESEND_CONFIRMATION_ERROR: "Non siamo riusciti a inviare l'email di conferma. Riprova più tardi.",
  SHOW_PASSWORD: 'Mostra password',
  HIDE_PASSWORD: 'Nascondi password',

  MODAL_OK: 'OK',
  MODAL_CANCEL: 'Annulla',
  MODAL_DUPLICATE_FILE_TITLE: 'File duplicato',
  MODAL_DUPLICATE_FILE_DESCRIPTION: 'Hai già caricato un file con il seguente nome:',

  PLUS_MATERIAL_HINT: 'Ideali per immersione in secchiello del ghiaccio',
  LOADING_DATA_ISSUE_JOB: 'Attendere mentre recuperiamo le configurazioni del processo...',
  SHOW_UNIT_COUNT: 'Mostra il numero di unità',
  LOT: 'LOT (Opzionale)',
  LINE_1: 'riga 1',
  LINE_2: 'riga 2',
  LINE_3: 'riga 3',
  LINE_4: 'riga 4',
  PROOFING_SERVICE: 'Prova di stampa',

  ORDER_TEMPLATES_TITLE: "Modelli d'ordine",
  ORDER_TEMPLATES_SELECT: "Modello d'ordine selezionato",
  ORDER_TEMPLATES_SELECT_PLACEHOLDER: "Seleziona un modello d'ordine",
  ORDER_TEMPLATES_NO_TEMPLATES: "Non sono disponibili modelli d'ordine.",

  PRODUCTION_TYPE_STANDARD: 'Standard',
  PRODUCTION_TYPE_EXPRESS: '48h Espressa',
  PRODUCTION_TYPE_SUPER_EXPRESS: '24h Super Espressa',
  PRODUCTION_TYPE_ESTIMATED_SHIPPING_DATE: 'Invio stimato il',
  PRODUCTION_TYPE_SHIPPING_DATE: 'Invio il',
  PRODUCTION_TYPE_NOT_POSSIBLE: 'Non disponibile',

  SHOW_PRICE_IN_CURRENCY: 'Mostra il prezzo in {currency}',
  CURRENCY_SWITCH_DISABLED_CART_NOT_EMPTY: 'La valuta non può essere modificata finché il carrello contiene articoli.',
  CART_MIXED_CURRENCY_WARNING:
    'Il tuo carrello contiene articoli in valute diverse. Rimuovi gli articoli in una valuta diversa prima di procedere al pagamento.',
  CHECKOUT_USER_DISABLED: 'Il tuo account non è autorizzato a effettuare ordini. Contatta il nostro servizio clienti.',
  DESIGN_SERVICE_CURRENCY_DISABLED: 'Il Design Service può essere ordinato solo in {currency}.',
  PACKAGE_ORDER_CURRENCY_DISABLED: 'Questo pacchetto può essere ordinato solo in {currency}.',
  CHANGE_CURRENCY_CALCULATOR: 'Modifica prima la valuta nel calcolatore della homepage.',

  CART_ITEM_DISCOUNT_NOT_APPLICABLE:
    'Nessuno sconto cliente sarà concesso su questo articolo a causa di prezzi speciali.',
  UPLOAD_SORTS_CONFIG_NOT_SAVED:
    'Non è stato possibile salvare la configurazione delle varianti. Verifica che le quantità di tutte le varianti corrispondano alla quantità totale e riprova.',
  HPI_WHITE: 'Bianco opaco',
  YES: 'Si',
  NO: 'No',

  UPS_STANDARD_SHIPPING: 'UPS Standard',
  UPS_EXPRESS_SHIPPING: 'UPS Express Saver',
  UPS_STANDARD_SHIPPING_NEUTRAL: 'UPS Standard – Compensazione delle emissioni di CO₂',
  UPS_EXPRESS_SHIPPING_NEUTRAL: 'UPS Express Saver – Compensazione delle emissioni di CO₂'
} as const
